import { Deserializable } from '../_common/deserializable';

export class ScSelection implements Deserializable{
    source: number;
    shortCode: string;
    keyword: string;
    operator: string;
    scView: string;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
